import { OnboardingProgress } from '../components/OnboardingProgress';
import { ProfileStep } from '../components/ProfileStep';
import { StrategyStep } from '../components/StrategyStep';
import { IntegrationsStep } from '../components/IntegrationsStep';
import { CompleteStep } from '../components/CompleteStep';
import { useOnboarding } from '../hooks/useOnboarding';
import styles from './OnboardingPage.module.css';

const STEPS = [
  { label: 'Practice Profile', description: 'Basic info about your practice' },
  { label: 'Strategy', description: 'Goals and target patients' },
  { label: 'Integrations', description: 'Connect your marketing tools' },
  { label: 'Complete', description: 'You\'re ready to go!' },
];

export function OnboardingPage() {
  const {
    currentStep,
    setCurrentStep,
    saveProfile,
    isSavingProfile,
    saveStrategy,
    isSavingStrategy,
    saveIntegrations,
    isSavingIntegrations,
    complete,
    isCompleting,
  } = useOnboarding();

  return (
    <div className={styles.page}>
      <div className={styles.sidebar}>
        <div className={styles.logo}>
          <span className={styles.logoMark}>PN</span>
          <span className={styles.logoText}>PracticeNova</span>
        </div>
        <h1 className={styles.sidebarTitle}>Welcome! Let's get you set up.</h1>
        <p className={styles.sidebarSubtitle}>
          Complete these steps to personalize your experience and start getting recommendations.
        </p>
        <OnboardingProgress steps={STEPS} currentStep={currentStep} />
      </div>

      <div className={styles.main}>
        <div className={styles.card}>
          <div className={styles.stepHeader}>
            <span className={styles.stepNumber}>Step {currentStep + 1} of {STEPS.length}</span>
            <h2 className={styles.stepTitle}>{STEPS[currentStep].label}</h2>
            <p className={styles.stepDescription}>{STEPS[currentStep].description}</p>
          </div>

          <div className={styles.stepContent}>
            {currentStep === 0 && (
              <ProfileStep onSubmit={saveProfile} isLoading={isSavingProfile} />
            )}
            {currentStep === 1 && (
              <StrategyStep
                onSubmit={saveStrategy}
                onBack={() => setCurrentStep(0)}
                isLoading={isSavingStrategy}
              />
            )}
            {currentStep === 2 && (
              <IntegrationsStep
                onSubmit={saveIntegrations}
                onBack={() => setCurrentStep(1)}
                isLoading={isSavingIntegrations}
              />
            )}
            {currentStep === 3 && (
              <CompleteStep onComplete={complete} isLoading={isCompleting} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
